import { DocumentAuditPage } from '@/features/auditoria-v2/DocumentAuditPage';

export default function AuditoriaV2() {
  return <DocumentAuditPage />;
}
